export const tokenAddresses = {
  EUL: "0x3eBd0148BADAb9388936E4472C4415D5700478A5",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0xe15C5F31cd7B767883F5654CDD3aFac28966B0a9",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
